/**
 * Functionalities a role can grant, identified by the `name` sent by the backend in
 * IOrganizationAccess.functionalities (the numeric id is not relied upon).
 */
export enum Functionality {
  IMPORT_DATA = "IMPORT_DATA",
  EXPORT_DATA = "EXPORT_DATA",
  OPEN_GRAFANA = "OPEN_GRAFANA",
  MODIFY_DATA = "MODIFY_DATA",
  CREATE_ORGANIZATION = "CREATE_ORGANIZATION",
  CREATE_LANGUAGE = "CREATE_LANGUAGE",
  DISABLE_LANGUAGE = "DISABLE_LANGUAGE",
  MODIFY_LANGUAGE = "MODIFY_LANGUAGE",
  EDIT_TRANSLATIONS = "EDIT_TRANSLATIONS",
  VIEW_ORGANIZATIONS = "VIEW_ORGANIZATIONS",
  INVITE_MEMBER = "INVITE_MEMBER",
  REVOKE_INVITATION = "REVOKE_INVITATION",
  RESEND_INVITATION = "RESEND_INVITATION",
  MAKE_PREDICTION = "MAKE_PREDICTION",
  REMOVE_MEMBER = "REMOVE_MEMBER",
  CHANGE_MEMBER_ROLE = "CHANGE_MEMBER_ROLE",
}
